const PREFIX = 'EnableUs.Authorization';
export const ACCESS_TOKEN_KEY = `${PREFIX}.AccessToken`;
export const TOKEN_TYPE_KEY = `${PREFIX}.TokenType`;

export interface SignInData {
  accessToken: string;
  nextPath?: string;
  tokenType: string;
}
